/** CoStar.Api.AptsReviews.ViewModels.Moderation.ModerationEntityType */
export var ModerationEntityType;
(function (ModerationEntityType) {
    ModerationEntityType[ModerationEntityType["None"] = 0] = "None";
    ModerationEntityType[ModerationEntityType["Review"] = 1] = "Review";
    ModerationEntityType[ModerationEntityType["Comment"] = 2] = "Comment";
})(ModerationEntityType || (ModerationEntityType = {}));
/** CoStar.Api.AptsReviews.ViewModels.Moderation.ModerationStatus */
export var ModerationStatus;
(function (ModerationStatus) {
    ModerationStatus[ModerationStatus["Unknown"] = 0] = "Unknown";
    ModerationStatus[ModerationStatus["Pending"] = 10] = "Pending";
    ModerationStatus[ModerationStatus["Approved"] = 20] = "Approved";
    ModerationStatus[ModerationStatus["Rejected"] = 30] = "Rejected";
    ModerationStatus[ModerationStatus["Hidden"] = 50] = "Hidden";
})(ModerationStatus || (ModerationStatus = {}));
/** CoStar.Api.AptsReviews.ViewModels.Moderation.ModerationAction */
export var ModerationAction;
(function (ModerationAction) {
    ModerationAction[ModerationAction["Unknown"] = 0] = "Unknown";
    ModerationAction[ModerationAction["Started"] = 10] = "Started";
    ModerationAction[ModerationAction["Approved"] = 20] = "Approved";
    ModerationAction[ModerationAction["Rejected"] = 30] = "Rejected";
    ModerationAction[ModerationAction["Skipped"] = 40] = "Skipped";
    ModerationAction[ModerationAction["Hidden"] = 50] = "Hidden";
})(ModerationAction || (ModerationAction = {}));
/** CoStar.Api.AptsReviews.ViewModels.Moderation.EntityType */
export var EntityType;
(function (EntityType) {
    EntityType[EntityType["ListingId"] = 1] = "ListingId";
    EntityType[EntityType["PropertyId"] = 2] = "PropertyId";
})(EntityType || (EntityType = {}));
/** CoStar.Api.AptsReviews.ViewModels.Moderation.ModerationStatusFilter */
export var ModerationStatusFilter;
(function (ModerationStatusFilter) {
    ModerationStatusFilter[ModerationStatusFilter["None"] = 0] = "None";
    ModerationStatusFilter[ModerationStatusFilter["Pending"] = 1] = "Pending";
    ModerationStatusFilter[ModerationStatusFilter["Approved"] = 2] = "Approved";
    ModerationStatusFilter[ModerationStatusFilter["Rejected"] = 4] = "Rejected";
    ModerationStatusFilter[ModerationStatusFilter["Hidden"] = 8] = "Hidden";
})(ModerationStatusFilter || (ModerationStatusFilter = {}));
/** CoStar.Api.AptsReviews.ViewModels.Moderation.SearchType */
export var SearchType;
(function (SearchType) {
    SearchType[SearchType["Unknown"] = 0] = "Unknown";
    SearchType[SearchType["ListingId"] = 1] = "ListingId";
    SearchType[SearchType["PropertyId"] = 2] = "PropertyId";
    SearchType[SearchType["HeadquartersId"] = 3] = "HeadquartersId";
    SearchType[SearchType["ReviewId"] = 4] = "ReviewId";
})(SearchType || (SearchType = {}));
/** CoStar.Api.AptsReviews.ViewModels.Moderation.SortBy */
export var SortBy;
(function (SortBy) {
    SortBy[SortBy["Default"] = 0] = "Default";
    SortBy[SortBy["DateSubmitted"] = 1] = "DateSubmitted";
    SortBy[SortBy["ModerationDate"] = 2] = "ModerationDate";
    SortBy[SortBy["ModeratorName"] = 3] = "ModeratorName";
    SortBy[SortBy["OriginLanguageName"] = 4] = "OriginLanguageName";
    SortBy[SortBy["Status"] = 5] = "Status";
    SortBy[SortBy["CommentCount"] = 6] = "CommentCount";
    SortBy[SortBy["PropertyName"] = 7] = "PropertyName";
    SortBy[SortBy["Rating"] = 8] = "Rating";
    SortBy[SortBy["FlaggingCount"] = 9] = "FlaggingCount";
})(SortBy || (SortBy = {}));
/** CoStar.Api.AptsReviews.ViewModels.Moderation.SortDirection */
export var SortDirection;
(function (SortDirection) {
    SortDirection[SortDirection["Default"] = 0] = "Default";
    SortDirection[SortDirection["Ascending"] = 1] = "Ascending";
    SortDirection[SortDirection["Descending"] = 2] = "Descending";
})(SortDirection || (SortDirection = {}));
